export const PURCHASE_TYPE = {
  NEW: 1,
  UPGRADE: 2,
  EXTEND: 3
};

export const PURCHASE_TYPE_TEXT = {
  [PURCHASE_TYPE.NEW]: "خرید اشتراک",
  [PURCHASE_TYPE.UPGRADE]: "ارتقاء امکانات",
  [PURCHASE_TYPE.EXTEND]: "تمدید اشتراک"
};

export const PURCHASE_STEPS_TYPE = {
  CREATE_PROJECT: 1,
  CHOOSE_PLAN: 2,
  CHOOSE_PLAN_OPTIONS: 3,
  CONFIRM_PLAN: 4,
  FINAL_PAYMENT: 5
};

export const PURCHASE_STEPS_TYPE_TEXT = [
  {
    type: PURCHASE_STEPS_TYPE.CREATE_PROJECT,
    text: "ایجاد پروژه",
    canHide: true
  },
  { type: PURCHASE_STEPS_TYPE.CHOOSE_PLAN, text: "انتخاب طرح", canHide: true },
  { type: PURCHASE_STEPS_TYPE.CHOOSE_PLAN_OPTIONS, text: "انتخاب منابع" },
  { type: PURCHASE_STEPS_TYPE.CONFIRM_PLAN, text: "تایید طرح" },
  { type: PURCHASE_STEPS_TYPE.FINAL_PAYMENT, text: "پرداخت نهایی" }
];

export const PURCHASE_USED_KEY = {
  FORM_STEP: "FORM_STEP",
  PROJECT_ID: "PROJECT_ID",
  PROJECT_NAME: "PROJECT_NAME",
  PLAN_ID: "PLAN_ID",
  VOLUME_SIZE: "VOLUME_SIZE",
  USER_COUNT: "USER_COUNT",
  PURCHASE_ACTION: "PURCHASE_ACTION"
};